import { setCurrentErrorPage } from '../boot/errorHandler'

export const showTotalErrorPage = async (errorPageName, pageProps) => {
  window.onResourcesLoaded?.()

  let errorPageContainer = document.getElementById('fullscreenErrorPageContainer')
  if (!errorPageContainer) {
    errorPageContainer = document.createElement('div')
    errorPageContainer.id = 'fullscreenErrorPageContainer'
    errorPageContainer.style.height = '100vh'
    document.body.insertBefore(errorPageContainer, document.body.firstChild)
  }

  // Nutze den bestehenden Error-Handler
  setCurrentErrorPage(errorPageName)
}

export const showErrorPage = async (errorPageName, pageProps) => {
  setCurrentErrorPage(errorPageName)
}
